import {Box, Flex} from '@chakra-ui/layout';
import {IconX} from '@tabler/icons';
import React, {FC} from 'react';
import {ModalTypes, useModalContext} from '..';
import {Actions, actions} from './actions';
import {Content} from './content';
import {Header} from './header';
import {Navigation} from './navigation';
import {Title, titles} from './title';

export const Container: FC<{type: ModalTypes}> = ({type}): JSX.Element => {
  const {onClose} = useModalContext();

  return (
    <>
      <Box
        as="button"
        onClick={onClose}
        pos="absolute"
        top={{base: 5, lg: 20}}
        right={{base: 'inherit', lg: 20}}
        left={{base: 3, lg: 'inherit'}}
      >
        <IconX size="24px" color="white" stroke="2" />
      </Box>
      <Box maxW={{base: '600px', xl: '726px'}} width="100%">
        <Header />
        <Flex
          w="100%"
          justifyContent="space-between"
          alignItems="center"
          mb={4}
        >
          <Title text={titles[type]} />
          <Actions action={actions[type]} />
        </Flex>
        <Content />
      </Box>
      <Navigation type={type} />
    </>
  );
};
